import { useState } from "react";
import SettingsIndex from "./SettingsIndex";
import {
  RavenButton,
  RavenCheckBox,
  RavenInputField,
} from "@ravenpay/raven-bank-ui";
import { useDispatch, useSelector } from "react-redux";
import { veryfyRcNumber } from "../../../redux/insight";
import BadgeComponent from "../../../fragments/badge/BadgeComponent";
import cacImage from "../../../assets/Frame 2147223890.png";
import pdfImage from "../../../assets/FE27A792-8B7F-4B48-BA15-CA343515A50A 2.png";
import RootState from "../../../redux/types";
import { debounce } from "lodash";
import { ThreeDots } from "react-loader-spinner";
const CacVerificationIndex = () => {
  const { loading_rc } = useSelector((state: RootState) => state.insights);
  const [currentStep, setCurrentStep] = useState<
    "cacRc" | "rcNumber" | "selectBusiness" | "cacResult"
  >("cacRc");
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [businessInfo, setBusinessInfo] = useState({
    firstName: "Abigail",
    lastName: "Uye",
    address: "20 The Quad Layi Yusuf Lekki Lagos",
    businessName: "Regius portus",
    emmailAddress: "abby@gmail.com",
    phoneNumber: "09078654433",
    businessIndustry: "Beauty",
    employeeCount: "50-100",
    accountNumber: "2348588865",
    bankName: "Gtb",
  });
  const [memartFile, setMemartFile] = useState<File | null>();
  const handleMemartFileChange = (event: File) => {
    setMemartFile(event);
  };

  const handleDisable = () => {
    return !rcNumber;
  };
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [rcNumber, setRcNumber] = useState("");
  const loading = false;
  const [notValidRcNumber, setNotValidRcNumber] = useState(false);
  const [file, setFile] = useState<File | null>();
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setIsModalOpen(true); // open modal after selecting file
    }
  };
  const [loadingRc, setLoadingRc] = useState(false);
  const handleVerifyRcNumber = debounce(async (userRcNumber: string) => {
    if (userRcNumber.length > 5) {
      setNotValidRcNumber(false);
      setLoadingRc(true);
    }
   
    setRcNumber(userRcNumber);
    const data = await dispatch(
      veryfyRcNumber({ rcNumber: userRcNumber }) as any
    );

    if (data?.payload?.status === "fail") {
      setLoadingRc(false);
    }

    if (data?.status === "success") {
      setLoadingRc(false);
      setBusinessInfo(data.data.data);
    } else {
      setNotValidRcNumber(true);
    }
  }, 50);

  //

  //   const handleVerifyRcNumber = debounce((param: any) => {
  //     const serialVal = localStorage?.getItem("takwoski");
  //     const decryptedVal = decrypt2(serialVal ?? "");
  //     const obj = {
  //       serial: decryptedVal,
  //       search: param,
  //     };
  //     if (param?.length > 0) {
  //       dispatch(getSingleInsightTerminalTransactions(obj as any) as any);
  //     } else {
  //       getTerminalDetailsTrans(decryptedVal);
  //     }
  //   }, 500);

  //   const debouncedVerify = debounce((rcNumber: string) => {
  //     handleVerifyRcNumber(rcNumber); // still async, but debounce doesn’t await it
  //   }, 500);
  const businessOptions = [
    {
      type: "Limited liability",
      name: "Mauritous Nigeria Limited",
    },
    {
      type: "Limited liability",
      name: "Raven Nigeria Limited",
    },
  ];
  const [selectedBusiness, setSelectedBusiness] = useState<string | null>(null);
  return (
    <SettingsIndex>
      <div
        className={`border-theme settings-right-side-wrap-cont-inner-cac ${
          ["rcNumber", "selectBusiness", "cacResult"].includes(currentStep)
            ? "rcnumber"
            : ""
        }`}
      >
        {currentStep === "cacRc" && (
          <div className="settings-right-side-wrap-cont-heading-cac">
            <p className="settings-right-side-wrap-cont-heading-header">
              CAC Verification
            </p>

            <div className="cac-verification-first-screen-inner-div">
              <p className="cac-verification-first-screen-inner-div-text">
                Verify your CAC Certificate
              </p>
              <RavenButton
                color="deep-green-light"
                label="Verify CAC Certificate"
                onClick={() => setCurrentStep("rcNumber")}
              />
            </div>
          </div>
        )}
        {(currentStep === "rcNumber" || currentStep === "selectBusiness") && (
          <div className="rc-number-input-div">
            <div className="rc-number-input-div-input-fields">
              <RavenInputField
                placeholder="RC Number"
                type="account-number"
                label="RC Number* "
                color="deep-green-light"
                className="rc-number-holder"
                errorText="Please enter a valid RC Number"
                // labelSpanText={loading_rc ? "loading.." : "Verify"}
                labelSpanText={
                  loading_rc || loadingRc ? (
                    <>
                      <div
                        style={{
                          padding: "0rem",
                          display: "flex",
                          justifyContent: "flex-end",
                          transform: "translateX(1.5rem)",
                        }}
                        className="load-wrap"
                      >
                        <ThreeDots
                          height="10"
                          width="80"
                          radius="9"
                          // color="#020202"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          visible={true}
                        />
                      </div>
                    </>
                  ) : (
                    ("" as any)
                  )
                }
                showError={notValidRcNumber}
                maxLength={9}
                onActionClick={() => {
                  console.log("call api");
                }}
                value={rcNumber}
                onChange={(e: any) => handleVerifyRcNumber(e.target.value)}
              />

              {currentStep === "selectBusiness" && (
                <div className="rc-number-select-your-business-box-general">
                  <div className="rc-number-select-your-business-box-genera-l-select">
                    <p className="rc-number-select-your-business-box-line"></p>
                    <p className="rc-number-select-your-business-box-text">
                      Select your business
                    </p>
                    <p className="rc-number-select-your-business-box-line"></p>
                  </div>

                  <div className="rc-number-business-type-general-wrap">
                    {businessOptions.map((business, index) => (
                      <div
                        key={index}
                        className="rc-number-business-type-general-box"
                        onClick={() => {
                          console.log(selectedBusiness);
                          setSelectedBusiness(business.name);
                        }}
                      >
                        <div className="show-check-box">
                          <p className="rc-number-business-type-general-value">
                            {business.type}
                          </p>

                          {selectedBusiness === business.name && (
                            <RavenCheckBox
                              checked={true}
                              id={983744322}
                              color="deep-green-light"
                              onChange={console.log}
                            />
                          )}
                        </div>
                        <p className="rc-number-business-type-general-header">
                          {business.name}
                        </p>
                      </div>
                    ))}
                  </div>

                  {selectedBusiness !== null && (
                    <div className="memart-and-cac-upload-input">
                      <RavenInputField
                        type="upload"
                        color="deep-green-light"
                        label="Upload your CAC Certificate"
                        value={file}
                        onChange={handleFileChange}
                      />
                      <span className="upload__file-size">
                        Maximum file size acceptable for upload is 2MB
                      </span>
                      <RavenInputField
                        type="upload"
                        color="deep-green-light"
                        label="Upload MEMART"
                        value={memartFile}
                        onChange={handleMemartFileChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Proceed Button */}

            <div className="proceed-button-div">
              <RavenButton
                color="deep-green-light"
                label="Proceed"
                className="proceed-button"
                disabled={handleDisable()}
                onClick={() =>
                  setCurrentStep(
                    currentStep === "selectBusiness"
                      ? "cacResult"
                      : "selectBusiness"
                  )
                }
              />
            </div>
          </div>
        )}
        {currentStep === "cacResult" && (
          <div className="recipt-view-box-holder">
            <p className="receipt-view-box-holder-header-text">
              CAC Verification
            </p>
            <div className="recipt-view-box-holder-div">
              <p className="recipt-view-box-holder-div-text">
                CAC Certificate verification successful
              </p>
              <div className="recipt-view-box-holder-div-containerap">
                <p className="cac-memart-image-text-bold">RC Number</p>
                <p className="cac-memart-image-text-light">RC 1234567</p>
              </div>
              <div className="recipt-view-box-holder-div-containerap">
                <p className="cac-memart-image-text-bold">Business Name</p>
                <p className="cac-memart-image-text-light">
                  Mauritous Nigeria Limited
                </p>
              </div>

              <div className="recipt-view-box-holder-div-containerap-image-side">
                <div className="recipt-view-box-holder-div-containerap-inner">
                  <div className="recipt-view-box-holder-div-containerap-inner-image">
                    <img src={cacImage} alt="" />
                  </div>
                  <p className="cac-memart-image-text">CAC Certificate.img</p>
                </div>
                <BadgeComponent
                  className={"badge-component"}
                  text={"accepted"}
                />
              </div>

              <div className="recipt-view-box-holder-div-containerap-image-side">
                <div className="recipt-view-box-holder-div-containerap-inner">
                  <div className="recipt-view-box-holder-div-containerap-inner-image">
                    <img src={pdfImage} alt="" />
                  </div>
                  <p className="cac-memart-image-text">MEMART.pdf</p>
                </div>
                <BadgeComponent
                  className={"badge-component"}
                  text={"accepted"}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </SettingsIndex>
  );
};

export default CacVerificationIndex;
